import { useState } from "react";

/**
 * Hook for managing dialog states
 */
export const useDialogStates = () => {
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [openExportDialog, setOpenExportDialog] = useState(false);
  const [openSingleRxDialog, setOpenSingleRxDialog] = useState(false);
  const [openTestTypeDialog, setOpenTestTypeDialog] = useState(false);

  const closeAllDialogs = () => {
    setOpenDeleteDialog(false);
    setOpenExportDialog(false);
    setOpenSingleRxDialog(false);
    setOpenTestTypeDialog(false);
  };

  return {
    openDeleteDialog,
    setOpenDeleteDialog,
    openExportDialog,
    setOpenExportDialog,
    openSingleRxDialog,
    setOpenSingleRxDialog,
    openTestTypeDialog,
    setOpenTestTypeDialog,
    closeAllDialogs,
  };
};
